
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 22","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.998 15.492a.886.886 0 011.32.062.759.759 0 001.177.002.88.88 0 011.247-.11.88.88 0 01.11 1.246.88.88 0 01-1.246.11l-.006-.004c-.038-.028-.069-.064-.108-.108l-.003-.004a.735.735 0 00-.582-.266c-.227 0-.44.1-.583.274a.861.861 0 01-.684.319.893.893 0 01-.895-.89.876.876 0 01.253-.631zm.636 3.027c.455 0 .894-.126 1.273-.366a2.373 2.373 0 001.731.322 2.398 2.398 0 001.537-1.014c.36-.53.491-1.17.369-1.802a2.397 2.397 0 00-1.013-1.537 2.389 2.389 0 00-2.624-.046 2.404 2.404 0 10-1.274 4.443z"}}),_c('path',{attrs:{"d":"M1.513 3.745c0-.726.577-1.317 1.286-1.317h18.058c.702 0 1.273.59 1.273 1.317v.636H6.22c-1.553 0-2.817 1.253-2.817 2.793v8.93h-.606l-.011.001a1.271 1.271 0 01-1.274-1.254zm22.772 2.15c.723 0 1.311.573 1.311 1.279v.8H4.916v-.8a1.292 1.292 0 011.304-1.28zm1.305 3.592v1.386H4.916V9.487zm-20.674 2.9H25.59v5.867a1.331 1.331 0 01-1.311 1.318H6.222a1.32 1.32 0 01-1.306-1.318zm22.187-.902V8.882c0-.015.004-.038.01-.061a.584.584 0 00.015-.122.551.551 0 00-.016-.12.317.317 0 01-.01-.057V7.174c0-1.54-1.266-2.793-2.823-2.793h-.643v-.636c0-1.56-1.25-2.83-2.786-2.83H2.8C1.255.915 0 2.185 0 3.745v11.08a2.79 2.79 0 002.78 2.793h.624v.637a2.844 2.844 0 002.817 2.83h18.06a2.855 2.855 0 002.822-2.83v-6.417c0-.015.005-.04.01-.062a.547.547 0 00.015-.115.547.547 0 00-.015-.114.356.356 0 01-.01-.062z"}})])
          )
        }
      }
    